import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './home.css';

import hero1 from '../assets/imgs/hero1.png';
import hero2 from '../assets/imgs/hero2.png';
import hero3 from '../assets/imgs/hero3.png';

import editaLogo from '../assets/icons/silverSponsor.svg';
import nbeLogo from '../assets/icons/platinumSponsor.svg';
import weLogo from '../assets/icons/officialTelecom.svg';
import egyptPostLogo from '../assets/icons/shippingPartner.svg';
import book from '../assets/icons/book.svg';
import explore from '../assets/icons/explore.svg';
import calendar from '../assets/icons/calendar.svg';
import { supabase } from '../supabase';
import BottomNav from '../components/layout/bottomNav';
import MobileHeader from '../components/layout/mobileHeader';

const heroSlides = [
  {
    image: hero1,
    title: 'Save the date!',
    subtitle: 'January 25 - February 7',
    location: "Egypt’s International Exhibition Center",
    time: '10:00 AM - 9:00 PM Daily',
    button: 'Book Now!',
    path: '/Book',
  },
  {
    image: hero2,
    title: 'Personalities of the fair',
    subtitle: 'Radwa Ashour & Mahmoud Salem',
    button: 'Explore',
    path: '/Explore',
  },
  {
    image: hero3,
    title: 'A Legacy of Literature',
    subtitle: 'Since 1969, the Cairo International Book Fair has been the beating heart of Arabic literature and culture.',
    button: 'Read More',
    path: '/Events',
  },
];

const Home = () => {
    const [exhibitors, setExhibitors] = useState([]);

    useEffect(() => {
        const loadExhibitors = async () => {
          const { data, error } = await supabase
            .from('exhibitors')
            .select('*')
            .eq('status', 'Approved')
            .order('created_at', { ascending: false })
            .limit(6);
      
          if (error) {
            console.error('Error loading exhibitors:', error.message);
            return;
          }
      
          setExhibitors(data || []);
        };
      
        loadExhibitors();
      }, []);
  const navigate = useNavigate();
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const slider = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % heroSlides.length);
    }, 3500);

    return () => clearInterval(slider);
  }, []);

  const slide = heroSlides[activeSlide];

  return (
    <main className="homePage">
        <MobileHeader />

      <section className="heroSlider">
        <div className="heroText">
          <h1>{slide.title}</h1>
          <h2>{slide.subtitle}</h2>

          {slide.location && <p>📍 {slide.location}</p>}
          {slide.time && <p>🕘 {slide.time}</p>}

          <button onClick={() => navigate(slide.path)}>
            {slide.button}
          </button>
        </div>

        <img src={slide.image} alt={slide.title} className="heroImage" />

        <div className="heroDots">
          {heroSlides.map((_, index) => (
            <span
              key={index}
              className={activeSlide === index ? 'activeDot' : ''}
              onClick={() => setActiveSlide(index)}
            />
          ))}
        </div>
      </section>

      <section className="sectionBlock">
        <h2>Quick Actions</h2>

        <div className="quickActions">
          <button onClick={() => navigate('/Book')}>
          <img src={book} alt="ticket icon" />
            <p>Book</p>
            <b>›</b>
          </button>

          <button onClick={() => navigate('/Explore')}>
            <img src={explore} alt="explore icon" />
            <p>Explore</p>
            <b>›</b>
          </button>

          <button onClick={() => navigate('/Events')}>
          <img src={calendar} alt="calendar icon" />
            <p>Events</p>
            <b>›</b>
          </button>
        </div>
      </section>

      <section className="sectionBlock">
        <div className="sectionHeader">
          <h2>Exhibitors</h2>
          <button onClick={() => navigate('/Explore')}>View all ›</button>
        </div>

        <div className="horizontalScroll">
            {exhibitors.map((exhibitor) => (
                <div
                className="exhibitorLogoCard"
                key={exhibitor.id}
                onClick={() => navigate('/Explore')}
                >
                <img src={exhibitor.logo_url} alt={exhibitor.name} />
                </div>
            ))}
            </div>
      </section>

      <section className="sectionBlock">
        <div className="sectionHeader">
          <h2>Partners</h2>
          <button>View all ›</button>
        </div>

        <div className="partnersRow">
          <img src={editaLogo} alt="Edita" />
          <img src={nbeLogo} alt="National Bank of Egypt" />
          <img src={weLogo} alt="WE" />
          <img src={egyptPostLogo} alt="Egypt Post" />
        </div>
      </section>

      <section className="sectionBlock bottomSpace">
        <h2>Fair Highlights</h2>

        <div className="highlightsCard">
          <div>
            <h3>1200+</h3>
            <p>Books</p>
          </div>

          <div>
            <h3>2M+</h3>
            <p>Visitors</p>
          </div>

          <div>
            <h3>14</h3>
            <p>Days</p>
          </div>
        </div>
      </section>

      <BottomNav />
    </main>
  );
};

export default Home;